import { createMarkup, isFieldError } from "../../utils";
import "./styles.css";

const Select = ({
	label,
	note = "",
	reqd,
	name,
	value,
	options,
	update,
	errors,
	autocomplete = name,
	placeholder = "",
	readonly = false,
}) => {
	return (
		<div className={isFieldError(errors, name) ? "has-error" : ""}>
			{label && (
				<label className="control-label" htmlFor={name}>
					<span dangerouslySetInnerHTML={createMarkup(label)} />{" "}
					<span className="reqd">{reqd ? "*" : " "}</span>
				</label>
			)}
			<select
				placeholder=""
				autoComplete="off"
				value={value ? value : ""}
				onChange={(e) => update(name, e.target.value)}
				className={
					isFieldError(errors, name)
						? "form-control error-border"
						: "form-control"
				}
				readOnly={readonly}
			>
				{options.map((item) => (
					<option key={item.id} value={item.id} disabled={item.disabled}>
						{item.name}
					</option>
				))}
			</select>
			<span className={note ? "note" : "hidden"}>{note}</span>
		</div>
	);
};

export default Select;
